import React, {useState, useEffect} from 'react';
import {Input, Button, Pagination} from "antd";
import Select from "react-select";
import Skeleton from "react-loading-skeleton";
import ApiService from "../util/ApiService";
import Swal from "sweetalert2";
import Modal from 'react-bootstrap/Modal';
import {Form} from 'react-bootstrap';
import LoadingScreen from "../util/LoadingScreen";
import Switch from "react-switch";
import ReactQuill from "react-quill";
import AuthService from "../login/AuthService";


const ModalCompanyConfigAccreditation = ({show, onHide}) => {
    const [loading, setLoading] = useState(false);
    const [loadingSave, setLoadingSave] = useState(false);
    const [formData, setFormData] = useState({
        accreditation: "",
        guide: ""
    });

    useEffect(() => {
        fetchListCompanyAssistant();
    }, [show]);

    const fetchListCompanyAssistant = async () => {

        try {
            setLoading(true);
            const companyId = AuthService.getCompanyId();
            setFormData([]);
           if(companyId){
            const response = await ApiService.send(
                "get",
                `${process.env.REACT_APP_URL_API}users/list-assistant`,
                {id: companyId},
                true
            );

            const {data} = ApiService.handleApiResponse(response);


            setFormData(data);
           }
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async () => {
        setLoadingSave(true);
        try {
            let response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}users/company-assistant`,
                formData,
                true
            );

            Swal.fire("Sucesso", "Configuração salva com sucesso!", "success").then(() => {
                onHide();
            });

        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoadingSave(false); // Finaliza o carregamento
        }
    };

    return (
        <>
            {loading && <LoadingScreen/>}
            <Modal show={show} onHide={onHide} centered size="lg">

                <Modal.Header closeButton>
                    <Modal.Title>Configurar Credenciamento</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <div className="row">
                            <div className="col-6  mb-1">
                                <label className="me-2">Aceitar credenciamento pela plataforma?</label><br/>
                                <Switch
                                    checked={formData.accreditation === 1}
                                    onChange={(checked) => setFormData({
                                        ...formData,
                                        accreditation: checked ? 1 : 0
                                    })}
                                    onColor="#0d6efd"
                                    offColor="#ccc"
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    title="Selecionar automaticamente o primeiro plantonista que se candidatar ao plantão"
                                    className="react-switch me-2"
                                />
                                <span>{formData.accreditation === 1 ? "Sim" : "Não"}</span>
                            </div>
                            {/*<div className="col-6 mb-1">*/}
                            {/*    <label className="me-2">Credenciamento obrigatório para pegar plantãoes?</label><br/>*/}
                            {/*    <div className="row">*/}
                            {/*        <Switch*/}
                            {/*            checked={formData.validated_user === 1}*/}
                            {/*            onChange={(checked) => setFormData({*/}
                            {/*                ...formData,*/}
                            {/*                validated_user: checked ? 1 : 0*/}
                            {/*            })}*/}
                            {/*            onColor="#0d6efd"*/}
                            {/*            offColor="#ccc"*/}
                            {/*            uncheckedIcon={false}*/}
                            {/*            checkedIcon={false}*/}
                            {/*            title="Selecionar automaticamente o primeiro plantonista que se candidatar ao plantão"*/}
                            {/*            className="react-switch me-2 col-6"*/}
                            {/*        />*/}
                            {/*        <span className="col-6">{formData.validated_user === 1 ? "Sim" : "Não"}</span>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                        </div>
                        <div className="form-group col-12 mt-3">
                            <label>Mensagem</label>
                            <ReactQuill
                                theme="snow"
                                value={formData.guide || ""}
                                onChange={(content) => setFormData({...formData, guide: content})}
                                placeholder="Digite o texto da mensagem..."
                                className="custom-quill mb-5"
                                modules={{
                                    toolbar: [
                                        [{header: [1, 2, false]}],
                                        ["bold", "italic", "underline"],
                                        [{list: "ordered"}, {list: "bullet"}],
                                        ["link"],
                                        ["clean"]
                                    ],
                                }}
                                formats={[
                                    "header", "bold", "italic", "underline",
                                    "list", "bullet", "link", "image"
                                ]}
                            />
                        </div>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={() => onHide()}>
                        <i className="fa fa-close"></i> Cancelar
                    </button>
                    <button type="button" className="btn btn-primary" onClick={() => handleSave()} disabled={loadingSave}>
                        {loadingSave ? (
                            <>
                                    <span
                                        className="spinner-border spinner-border-sm me-2"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                Salvando...
                            </>
                        ) : (
                            <>
                                <i className={`fa  fa-save me-2`}></i>
                                Salvar
                            </>
                        )}
                    </button>
                </Modal.Footer>
            </Modal>
        </>

    );
};


export default ModalCompanyConfigAccreditation;
